import { formatDateFile } from "@app/operations/market-nightly-refresh/utils";
import ProjectService from "@app/projects/projectService";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { FC, useRef, useState } from "react";
import { toast } from "react-toastify";

interface TableActionsProps {
  onDownload: () => void;
}

export const TableActions: FC<TableActionsProps> = ({ onDownload }) => {
  const [isExportingRunConfig, setIsExportingRunConfig] = useState(false);
  const projectService = useRef(new ProjectService()).current;

  const handleOpenRunConfig = (): void => {
    if (isExportingRunConfig) return;
    setIsExportingRunConfig(true);
    projectService
      .getProjectDetailsCsv(`Project Configurations(All)_${formatDateFile(new Date())}`)
      .catch(() => toast.error("Failed to export project run config.", { containerId: "z-index-9999" }))
      .finally(() => setIsExportingRunConfig(false));
  };

  return (
    <div className="market-nightly-refresh__table-actions">
      <QESButton qesType="outline" qesTestId="mnr-table__download" onClick={onDownload}>
        <QesIcon iconName={QesIcons.Download} isDecorative={true} /> Download table
      </QESButton>
      <QESButton
        qesType="outline"
        qesTestId="mnr-table__run-config"
        onClick={handleOpenRunConfig}
        disabled={isExportingRunConfig}
      >
        <QesIcon iconName={QesIcons.FileV4} isDecorative={true} /> Project run config
      </QESButton>
    </div>
  );
};
